import * as Constants from '../../../utils/Constants';

import {
  ClearAllWizard,
  GetAllPlaysByClientId,
  UpdateCampaignID,
} from '../../../redux/actions';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import toast from "../../../utils/toast";

import HelperFunctions from "../../../utils/HelperFunctions";
import StepWizard from "../../StepWizard";
import { trackPromise } from "react-promise-tracker";
import { withRouter } from "../../../utils/withRouter";

const CampaignSelection = (props) => {
  const navigate = useNavigate();
  const { selectedDesign } = props;
  const [searchText, setSearchText] = useState("");
  const [loadedPlaysClientIdList, setLoadedPlaysClientIdList] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(0);
  const dispatch = useDispatch();
  const { loadedPlaysClientId } = useSelector(
    (state) => state.marketingPlayConfiguration
  );
  const { campaignId } = useSelector((state) => state.wizard);
  const [clientId, setClientId] = useState(
    HelperFunctions.getCookie("selectedClientId")
  );

  useEffect(() => {
    trackPromise(dispatch(GetAllPlaysByClientId(clientId)));
  }, [clientId]);

  useEffect(() => {
    setSelectedCampaign(campaignId);
  }, [campaignId]);

  useEffect(() => {
    if (loadedPlaysClientId) {
      let list = [];
      loadedPlaysClientId?.map((obj) => {
        list.push({
          name: `${obj.playName} - ${obj.subtitle}`,
          marketingPlayId: obj.marketingPlayId,
        });
      });
      //apply sort
      list = list?.sort((a, b) => (a.name > b.name ? 1 : -1));

      setLoadedPlaysClientIdList(list);
    }
  }, [loadedPlaysClientId]);

  const searchHandleChange = (e) => {
    setSearchText(e.target.value);
  };

  const callback = (e) => {
    if (selectedCampaign) {
      trackPromise(
        dispatch(UpdateCampaignID(selectedCampaign)).then(() => {
          props.router.navigate("/ChooseAudience");
        })
      );
    } else {
      toast.warning("You must make a selection before continuing");
    }
  };

  const handleSelectedCampaign = (id) => {
    setSelectedCampaign(id);
    if (props.isPopupDisplay) {
      props.handleSelectedCampaignId(id);
    }
  };

  const prevCallback = () => {
    trackPromise(dispatch(ClearAllWizard()));
    navigate("/ManageCampaigns");
  };

  return (
    <div className="campaign-wizard-page">
      {props.isPopupDisplay ? null : (
        <StepWizard
          startFrom={Constants.STEP_WIZARD.Campaign}
          activeStep={Constants.STEP_WIZARD.Campaign}
          prevCallback={prevCallback}
          nextCallback={callback}
          hideBeforeStart={true}
          disableNext={false}
          showNext={true}
          hideSaveAndExitOption={true}
          showPrev={false}
        />
      )}
      <div className="container">
        <div className="row pt-25">
          <div className="col">
            <div className="heading">
              <h1 className="main-heading">Choose a Campaign</h1>
              <span className="info-text">
                Select an option below. Revenue totals will be recalculated
                overnight{" "}
              </span>
            </div>
            <div className="d-flex justify-content-center mt-4">
              <label htmlFor="search-bar" className="search-input-label">
                <input
                  id="search-bar"
                  name="searchText"
                  type="search"
                  className="search-input"
                  value={searchText}
                  onChange={searchHandleChange}
                  placeholder={"Search Campaigns"}
                />
              </label>
            </div>
          </div>
        </div>
        <div className="row w-auto m-auto card">
          <ul className="list-style-none">
            {props.isPopupDisplay && selectedDesign?.marketingPlayId && (
              <li className="d-flex my-2">
                <div className="w-75">
                  <input
                    type="radio"
                    name="size"
                    id="small"
                    value={0}
                    onClick={() => {
                      handleSelectedCampaign(-1);
                    }}
                    checked={selectedCampaign === -1 ? "checked" : ""}
                  />
                  <label className="ml-2" for="small">
                    <span className="form__radio-button"></span>
                    {"Uncategorized"}
                    <i
                      title="Emails that are not assigned to a specific Campaign are considered Uncategorized"
                      class="ml-2 fa fa-info-circle"
                    ></i>
                  </label>
                </div>
              </li>
            )}

            {loadedPlaysClientIdList
              ?.filter(
                (a) =>
                  (searchText == null && searchText == "") ||
                  (a.name?.toLowerCase().includes(searchText.toLowerCase()) &&
                    a.marketingPlayId !== selectedDesign?.marketingPlayId)
              )
              ?.map((obj) => {
                return (
                  <li className="d-flex my-2">
                    <div className="w-75">
                      <input
                        type="radio"
                        name="size"
                        id="small"
                        value={obj.marketingPlayId}
                        onClick={() => {
                          handleSelectedCampaign(obj.marketingPlayId);
                        }}
                        checked={
                          selectedCampaign == obj.marketingPlayId
                            ? "checked"
                            : ""
                        }
                      />
                      <label className="ml-2" for="small">
                        <span className="form__radio-button"></span>
                        {obj.name}
                      </label>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default withRouter(CampaignSelection);
